import { Text } from "@chakra-ui/react";
import { t } from "i18next";
import { AttributeDefinition, AttributeType } from "@keita/lanepatrol-sdk";
import { cellWidth } from "./constants";

export const Cell = ({
  attribute,
  value,
  suggested,
}: {
  attribute: AttributeDefinition;
  value: any;
  suggested: boolean;
}) => {
  var printedValue = value;
  if (value && attribute.type === AttributeType.Select) {
    printedValue = t(`sdk:attribute.option.${value}`);
  }

  return (
    <Text
      truncate
      w={`${cellWidth}px`}
      p={2}
      fontStyle={suggested ? "italic" : "normal"}
      opacity={suggested ? 0.6 : 1}
    >
      {printedValue ?? "-"}
    </Text>
  );
};
